//import 'bootstrap';
import './bootstrap.min.js';
import 'swiper/css/bundle';
// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
import './jquery.mapify.js'

var $ = jQuery;
$(document).ready(function() {
	initSwiper();
	setMainbottomShowcaseCSS();
});

function initSwiper() {

	const swiper = new Swiper('.swiper', {
	  // Optional parameters
	  speed: 400,
	  loop: true,

	  // If we need pagination
	  pagination: false,

	  // Navigation arrows
	  navigation: {
	    nextEl: '.swiper-button-next',
	    prevEl: '.swiper-button-prev',
	  },

	  // And if we need scrollbar
	  scrollbar: false,
	});

}

function setMainbottomShowcaseCSS()
{
	var container_width = $("#header").children('.container').width();
	$('.mainbottom-showcase-content').children('div').css('width', (container_width/2));
	console.log(container_width);
}

jQuery(document).ready(function(){
    jQuery("img[usemap]").mapify({
        popOver: {
            content: function(zone){ 
                return "<strong>"+zone.attr("data-title")+"</strong>";
            },
            delay: 0.7,
            margin: "15px",
            height: "60px",
            width: "140px"
        }
    });
    jQuery(document).ready(function(){
        //jQuery('[data-toggle="tooltip"]').tooltip(); 
    });
});

jQuery(function($) {
	
	$('ul li:last-child').addClass('lastItem');
	$('ul li:first-child').addClass('firstItem');

	// Modal Window
	$('[href="#modal"]').click(function(e){$('#modal').modal({show:true,backdrop:false});e.preventDefault()});

	$('#modal button.modalClose').click(function(e){$('#modal').modal('hide');e.preventDefault()});
	$('.modal-hide').click(function(e){$('#modal').modal('hide')});

	// hide #back-top first
	$("#back-top").hide();
	
	// fade in #back-top
	$(window).scroll(function () {
		if ($(this).scrollTop() > 100) {
			$('#back-top').fadeIn();
		} else {
			$('#back-top').fadeOut();
		}
	});

	var $scrollEl = ($.browser.mozilla || $.browser.msie) ? $('html') : $('body');

	// scroll body to 0px on click
	$('#back-top a').click(function(){$scrollEl.animate({scrollTop:0},400);return false});


    jQuery(document).ready(function(){
      jQuery('a.anchor-link').click(function(e) {
        e.preventDefault();

          var $target = jQuery(this.hash);
          $target = $target.length && $target
          || jQuery('[name=' + this.hash.slice(1) +']');
          if ($target.length) {
            var targetOffset = $target.offset().top;
            jQuery('html,body')
            .animate({scrollTop: targetOffset}, 1000);
           return false;
          }
      });
      $("a[data-toggle='tooltip']").on('click touchend', function(e) {
          var el = $(this);
          var link = el.attr('href');
          window.location = link;
      });
    });
    
  	// Height Script
	function setEqualHeight(){
      $(".height-before, .height-after").each(function(e) {
        if($(this).hasClass('height-before')) {
          var boxHeight = $(this).prev().find('.module_container').innerHeight();
        } else {
          var boxHeight = $(this).next().find('.module_container').innerHeight();
        }
        //console.log(boxHeight);
        $(this).find('.module_container').css('height',boxHeight);
      });
    }
  	setEqualHeight();
    $(window).on('resize', function(){
		setEqualHeight();
    });
    
});